import { ApolloLink } from '@apollo/client';

import { createAuthLink } from './createAuthLink';
import { createErrorLink } from './createErrorLink';
import { createHttpLink, type CreateHttpProps } from './createHttpLink';
import { removeTypeName } from './removeTypename';

export type CreateLinkProps = CreateHttpProps;
export const createLink = (props?: CreateLinkProps) => {
  // Order is important here: removeTypeName → error → auth → http
  return ApolloLink.from([
    removeTypeName,
    createErrorLink(),
    createAuthLink(),
    createHttpLink(props),
  ]);
};
